export enum ListingPositionEnum {
  notInSchedule = 'notInSchedule',
  startsBeforeScheduleStartButNotEnded = 'startsBeforeScheduleStartButNotEnded',
  startsAtScheduleStart = 'startsAtScheduleStart',
  startsAtScheduleStartAndIsEnded = 'startsAtScheduleStartAndIsEnded',
  startsBeforeScheduleStartAndEnded = 'startsBeforeScheduleStartAndEnded',
  startsAfterScheduleEnd = 'startsAfterScheduleEnd',
  duringSchedule = 'duringSchedule',
  duringScheduleEndsAfterScheduleEnd = 'duringScheduleEndsAfterScheduleEnd',
  // admittedly, these are edge cases, but they're possible
  startsBeforeScheduleStartEndsAtScheduleEnd = 'startsBeforeScheduleStartEndsAtScheduleEnd',
  startsAtScheduleStartEndsAfterScheduleEnd = 'startsAtScheduleStartEndsAfterScheduleEnd',
  listingSameAsSchedule = 'listingSameAsSchedule',
  listingLongerThanSchedule = 'listingLongerThanSchedule',
}

export interface Channel {
  profile?: string; // unconfirmed; ideally we will have this attribute in CS data
  feed_cid: string;
  digital_channel: string;
  analog_channel: string;
  short_name: string;
  full_name: string;
  timezone: string;
  feed_image: {
    white_logo?: string;
    color_logo?: string;
  };
  listings: Listing[];
  item_type: string;
}

export interface Listing {
  start_time: Date;
  duration: number;
  show_title: string;
  show_tms_id?: string;
  show_description?: string;
  episode_title: string;
  episode_description: string;
  tvss_episode_id: string;
  tvss_show_id: string;
  episode_schedule_url: string;
  episode_tms_id: string;
  show_schedule_url: string;
  listing_image: string | null;
  item_type: string;
  listing_position?: ListingPositionEnum;
}

export interface StationResource {
  cid: string;
  title: string;
  call_sign: string;
  mvod_enabled: boolean;
  short_common_name: string;
  primetime_start: number;
  kids_live_stream_url: string;
  timezone: string;
  secondary_timezone: string | null;
  donate_url: string;
  images: {
    'white-logo'?: string;
    'color-logo'?: string;
    'station-scenery-11'?: string;
    'white-cobranded-logo'?: string;
    'color-cobranded-logo'?: string;
  };
  schedule_url: string;
  passport_learn_more_url: string;
  passport_url: string;
  website_url: string;
  event_tracking: string;
  page_tracking: string;
  twitter_url: string;
  facebook_url: string;
  item_type: string;
  email: string;
  ga_live_stream_url: string;
  display_logo_overlay: boolean;
  ga_live_stream_feed_cid: string;
  livestream_fields: LivestreamField[];
}

export interface LivestreamField {
  profile: string;
  feed_cid: string;
  drm_hls_url: string;
  non_drm_url: string | null;
  drm_dash_url: string;
  logo_overlay: boolean;
  drm_fairplay_license_url: string;
  drm_widevine_license_url: string;
  drm_playready_license_url: string;
  feed_name: string;
}
